



















import {
	computed,
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import EditorWrapper from '../../layouts/form/EditorWrapper.vue';

export default defineComponent({
	components: {
		BasicTextEditor,
		EditorWrapper,
	},
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
	},
	setup(props) {
		const { update } = CurrentUserStore.actions;
		const el = ref(null as null | Element);
		const initialSummaryForContacts = computed(() => props.user.summaryForContacts);
		const textAreaValue = ref('');
		watch(initialSummaryForContacts, (curr: string) => {
			textAreaValue.value = curr;
		}, { immediate: true });

		const {
			track,
			clear,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();
		const saveUser = async () => {
			const summaryForContacts = textAreaValue.value;
			await track(update({ summaryForContacts }));
			clear(4000);
		};

		return {
			el,
			textAreaValue,
			saveUser,
			isLoading,
			isError,
			isSuccess,
			Spacing,
		};
	},
});
